import { feedItems } from '../data';
import { SectionHeader } from './SectionHeader';

export default function NewsFeed() {
  return (
    <section id="feed" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeader
          kicker="滚动快讯流"
          title="今日看瓜 · 最新动态时间线"
          desc="按时间倒序记录今天发生在各领域的最新动态，跟上时间线，热门变化一件不落。"
          link={{ label: '刷新看更新', href: '#feed' }}
        />

        <div className="relative feed-line">
          <div className="mb-2 ml-1 flex w-fit items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700 md:ml-5">
            <span className="live-dot inline-block h-1.5 w-1.5 rounded-full bg-accent-500" />
            正在滚动更新
          </div>

          <ul className="space-y-1">
            {feedItems.map((item, idx) => (
              <li key={idx}>
                <a
                  href="#channels"
                  className="group relative ml-4 flex items-start gap-3 rounded-xl px-2 py-2.5 transition-colors hover:bg-background-100 md:ml-6 md:gap-4"
                >
                  <span className="relative z-10 mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 border-background-50 bg-accent-400 shadow-none"></span>
                  <span className="w-20 shrink-0 pt-0.5 text-xs font-medium text-secondary-500 md:w-24 md:text-sm">
                    {item.time}
                  </span>
                  <span className="flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-600 md:text-[15px]">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="mt-0.5 shrink-0 rounded bg-primary-100 px-1.5 py-0.5 text-[10px] font-bold text-primary-600">
                      {item.hot}
                    </span>
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-6 flex items-center gap-3 rounded-2xl border border-dashed border-secondary-300 bg-background-100/60 px-4 py-4">
          <i className="ri-time-line text-secondary-500"></i>
          <p className="text-sm text-foreground-600">
            更早的今日动态已归档下沉，想回顾请进入对应栏目；时间线将持续跟随顶部更新条实时补充。
          </p>
          <a
            href="#faq"
            className="ml-auto hidden shrink-0 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-500 sm:inline-flex"
          >
            常见疑问<i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}